import React from 'react'
import { Tooltip } from 'antd'
import IconOk from '../Icons/IconOk'
import { useIntl } from 'react-intl'
import { useSelector, shallowEqual } from 'react-redux'
import IconNotConfirmed from '../Icons/IconNotConfirmed'
import { BLACK_COLOR, WHITE_COLOR } from '../../constants/colors'

const ConfirmedStatusIcon = ({ status }) => {
  const intl = useIntl()
  const theme = useSelector((state) => state.app.theme, shallowEqual)
  const color = theme === 'dark' ? WHITE_COLOR : BLACK_COLOR
  const isConfirmed = status === true
  const messageId = isConfirmed
    ? 'repairHistory.status.confirmed'
    : 'repairHistory.status.notConfirmed'
  const defaultMessage = isConfirmed ? 'VERIFIED' : 'NOT VERIFIED'

  const label = intl.formatMessage({
    id: messageId,
    defaultMessage,
  })

  const iconNode = isConfirmed ? (
    <IconOk
      enableOutline={true}
      circleStroke={color}
      stroke={color}
      fill={'none'}
      strokeWidth={1.4}
      width={23}
      height={23}
    />
  ) : (
    <IconNotConfirmed fill={color} width={25} height={25} />
  )

  return (
    <Tooltip
      title={label}
      mouseEnterDelay={0.1}
      placement="topRight"
      align={{ offset: [-8, -24] }}
      overlayClassName="repair-history-status-tooltip"
    >
      <span aria-label={label}>{iconNode}</span>
    </Tooltip>
  )
}

export default ConfirmedStatusIcon
